import { articles, type Article } from "@/mocks/chigua";
import SectionHeading from "@/components/chigua/SectionHeading";
import StoryCard from "@/components/chigua/StoryCard";

export default function LatestStream() {
  const list = articles.filter((a) => a.channel !== "shenba");
  const lead: Article = list[0];
  const rest = list.slice(1, 9);

  return (
    <section className="border-b border-background-200 bg-background-100/40">
      <div className="mx-auto max-w-[1400px] px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          eyebrow="红馆速递 · 娱圈观察"
          title="圈内最新，一条不落"
          desc="把最新动态与行业观察摊开讲清楚，快但不带节奏，帮你判断今天的圈子里发生了什么。"
          action="查看全部栏目"
          actionTo="/list/yingshi"
        />
        <div className="grid gap-8 lg:grid-cols-12">
          {/* 主打速递卡 */}
          <div className="lg:col-span-5">
            <article className="group sticky top-24 overflow-hidden rounded-xl border border-background-200 bg-foreground-950 text-background-100">
              <span className="pointer-events-none absolute -left-10 -top-10 h-40 w-40 rounded-full bg-secondary-500/20 blur-2xl" aria-hidden="true" />
              <div className="p-7 md:p-8">
                <span className="inline-flex items-center gap-1.5 rounded bg-primary-500 px-2.5 py-1 text-xs font-semibold text-background-50">
                  <i className="ri-radar-line" aria-hidden="true" />
                  主编精选速递
                </span>
                <p className="mt-5 text-xs uppercase tracking-[0.2em] text-secondary-300">
                  {lead.date} · {lead.kind}
                </p>
                <Link to={`/story/${lead.slug}`}>
                  <h3 className="mt-3 font-heading text-[22px] font-bold leading-snug text-background-50 transition group-hover:text-secondary-300 md:text-[26px]">
                    {lead.title}
                  </h3>
                </Link>
                <p className="mt-4 line-clamp-4 text-sm leading-6 text-background-300">{lead.excerpt}</p>
                <div className="mt-6 flex items-center gap-4 text-xs text-background-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-pencil-line" aria-hidden="true" />
                    {lead.author}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line" aria-hidden="true" />
                    {lead.minutes} 分钟
                  </span>
                </div>
                <Link
                  to={`/story/${lead.slug}`}
                  className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-5 py-2.5 text-sm font-semibold text-foreground-950 transition hover:bg-secondary-400"
                >
                  阅读全文
                  <i className="ri-arrow-right-line" aria-hidden="true" />
                </Link>
              </div>
            </article>
          </div>

          {/* 最新列表 */}
          <div className="grid gap-6 lg:col-span-7">
            <div className="grid gap-x-8 gap-y-6 sm:grid-cols-2">
              {rest.map((a) => (
                <StoryCard key={a.slug} item={a} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}